import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { ERROR_MESSAGES } from '../../../configs/messages';
import showMessage from '../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { ROUTES_LIST } from '../../../helpers/routesList';
import axios from 'axios';


function Copyright(props) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            {...props}
        >
            {'Зохиогчийн эрх © '}
            <Link color="inherit" href="https://www.mongolcontent.mn/">
                Mongol Content
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const theme = createTheme();

export default function RestorePasswordField() {
    const [errors, setErrors] = useState({});
    const [data, setData] = useState({
        password: '',
        confirmationPassword: '',
    });

    const history = useHistory();

    const { search } = useLocation();
    // console.log(search)
    // const auth = useAuth();

    const { enqueueSnackbar } = useSnackbar();

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setData({
            ...data,
            [name]: value,
        });
    };

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;
        const notMatched = ERROR_MESSAGES.NOT_MATCHED;

        if ('password' in data) {
            tempErrors.password = data.password ? '' : requiredMessage;
        }

        if ('confirmationPassword' in data) {
            tempErrors.confirmationPassword = data.confirmationPassword
                ? ''
                : requiredMessage;
        }

        const { password, confirmationPassword } = data;

        if (
            password &&
            confirmationPassword &&
            password !== confirmationPassword
        ) {
            tempErrors.password = notMatched;
        }

        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };

    const path = '/restore-password'
    const url = process.env.REACT_APP_CMS_API_PATH + path;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        const requestData = {
            password: data.password,
            confirmationPassword: data.confirmationPassword,
            token: new URLSearchParams(window.location.search).get('token'),
        };
    
        try {
            const response = await axios.post(url, requestData);
            showMessage(response.data?.data, enqueueSnackbar);
            history.push(ROUTES_LIST.login);
        } catch (err) {

            const message = err.response?.data?.message
                ? err.response.data.message
                : err.message;
    
            showMessage(message, enqueueSnackbar, 'error');
            console.error(err);
        }


        // sendJsonData(
        //     {
        //         password: data.password,
        //         confirmationPassword: data.confirmationPassword,
        //         token: search.replace('?token=', ''),
        //     },
        //     `/restore-password`,
        // )
        //     .then((response) => {
        //         showMessage(response.data?.data, enqueueSnackbar);
        //         history.push(ROUTES_LIST.login);
        //     })
        //     .catch((err) => {
        //         const message = err.response?.data?.message
        //             ? err.response.data.message
        //             : err.message;

        //         showMessage(message, enqueueSnackbar, 'error');
        //         console.error(err);
        //     });
    };

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                {/* <CssBaseline /> */}
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Нууц үг сэргээх
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        noValidate
                        sx={{ mt: 1 }}
                    >
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            type="password"
                            id="password"
                            label="Шинэ нууц үг"
                            name="password"
                            autoComplete="password"
                            autoFocus
                            onChange={handleInputChange}
                            error={Boolean(errors.password)}
                            helperText={errors.password}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            type="password"
                            id="confirmationPassword"
                            label="Шинэ нууц үг давталт"
                            name="confirmationPassword"
                            autoComplete="confirmationPassword"
                            onChange={handleInputChange}
                            error={Boolean(errors.confirmationPassword)}
                            helperText={errors.confirmationPassword}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Нууц үгээ солих
                        </Button>
                    </Box>
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}
